import React from "react";

import PageHeading from "../../../../components/common/PageHeading";
import Footer from "../../../../components/common/Footer";
import RightBar from "../../../../components/common/RightBar";
import FormAction from "../../../../components/common/FormAction";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";

import { Card, Col, Form, Input, Row, Select } from "antd";
import { propertiesunitscampaigns } from "../../../../data/guestcards";

const AddLockboxRightbar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("Showings With CodeBox", "1", "", "", ""),
  ]),
  RightBarMethod(
    "HELP TOPICS",
    "t2",
    <i className="fa-solid fa-circle-question"></i>,
    [
      RightBarMethod(
        "Allow Prospects to Schedule Self-Guided Showings",
        "2",
        "",
        "",
        ""
      ),
    ]
  ),
];

function AddLockbox() {
  return (
    <>
      <div className="page-container">
        <div className="main-container">
          <PageHeading heading="Add a Lockbox" />
          <div className="add-lockbox">
            <Form labelCol={{ span: 8 }} wrapperCol={{ span: 11 }}>
              <Row gutter={[0, 24]}>
                <Col span={24}>
                  <Card title="Lockbox Details">
                    <Form.Item label="Lockbox Name" required>
                      <Input placeholder="Lockbox Name Here" />
                    </Form.Item>
                    <Form.Item label="Unlock Code" required>
                      <Input placeholder="Unlock Code Here" />
                    </Form.Item>
                    <Form.Item label="Unit">
                      <Select
                        placeholder="Search by Unit"
                        options={propertiesunitscampaigns}
                      />
                    </Form.Item>
                  </Card>
                </Col>
                <Col span={24}>
                  <FormAction />
                </Col>
              </Row>
            </Form>
          </div>
          <Footer />
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={AddLockboxRightbar} />
      </div>
    </>
  );
}

export default AddLockbox;
